var path = 'src/app/components/common/help/help.template.html';
var html = "<div class=\"icon-question-sign help-icon\">\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;